import React from 'react';
import { Card } from '../components/ui/card';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Refund & Cancellation Policy</h1>
            <p className="text-xl text-gray-600">
               Last updated: April 2026
            </p>
          </div>

          {/* Content */}
          <Card className="p-8 md:p-12 border-pink-100 shadow-lg">
            <div className="prose prose-lg max-w-none text-gray-700">
              <p className="mb-8">
                Due to the digital nature of Ovalu services:
              </p>

              <ul className="list-disc pl-6 space-y-4 mb-8 text-lg">
                <li><strong>All purchases are final</strong></li>
                <li><strong>No refunds will be provided once the subscription is activated</strong></li>
              </ul>

              <div className="p-6 bg-pink-50 rounded-2xl border border-pink-100">
                <p className="mb-4">
                  If you face any technical issues, please contact support for assistance.
                </p>
                <p className="font-semibold text-[#FF6B9D] text-lg">
                  Email: support@ovalu.app
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPolicy;
